import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TertiaryCategoriesComponent } from './tertiary-categories.component';
import { AddTertiaryCategoriesComponent } from './add-tertiary-categories/add-tertiary-categories.component';
import { EditTertiaryCategoriesComponent } from './edit-tertiary-categories/edit-tertiary-categories.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [
        TertiaryCategoriesComponent,
        AddTertiaryCategoriesComponent,
        EditTertiaryCategoriesComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule
    ],
    exports: [
        TertiaryCategoriesComponent
    ]
})
export class TertiaryCategoriesModule { }
